import { useEffect, useState } from 'react';
import { UIProvider, ToastProvider, ErrorBoundary } from '@00start/ui';
import { transitSafeTheme } from './theme';
import { DemoPage } from './pages/DemoPage';
import { ChatPage } from './pages/ChatPage';

/**
 * Hash-based route switch. The demo has two pages:
 *   /              → 3-stage API walkthrough (DemoPage)
 *   /#chat         → streaming RAG chat (ChatPage)
 * Using `location.hash` rather than react-router avoids a new dependency
 * and keeps the bundle under the 200KB gzipped budget. The hash doesn't
 * hit the CF Pages _redirects, so there's no additional routing config.
 */
function useHashRoute(): string {
  const [hash, setHash] = useState<string>(() =>
    typeof window !== 'undefined' ? window.location.hash : '',
  );
  useEffect(() => {
    const onHashChange = () => setHash(window.location.hash);
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);
  return hash;
}

export function App() {
  const hash = useHashRoute();
  const route = hash === '#chat' ? 'chat' : 'demo';

  return (
    <UIProvider theme={transitSafeTheme}>
      <ErrorBoundary>
        <ToastProvider>
          {route === 'chat' ? <ChatPage /> : <DemoPage />}
        </ToastProvider>
      </ErrorBoundary>
    </UIProvider>
  );
}
